// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3H0N6","resendInfoText":"OnGoingPaymentBox_resendInfoText__25KzP"};